import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#060C18] text-white">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 py-24">
        <h1 data-testid="terms-title" className="text-4xl sm:text-5xl font-bold tracking-tight mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Terms of Service
        </h1>
        <p className="text-white/40 mb-12">Last updated: April 2026</p>

        <div className="space-y-10 text-white/70 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Acceptance</h2>
            <p>By using SendPI, you agree to these terms. If you do not agree, do not use the product.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">What SendPI is</h2>
            <p>SendPI is a communication intelligence tool currently in pilot testing. It is provided as-is for testing and feedback purposes. Features may change and the service may have interruptions.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Acceptable use</h2>
            <p>You agree to use SendPI only for lawful purposes. You must not use SendPI to generate harassment, threats, spam, or illegal content. You must not attempt to reverse engineer, scrape, or abuse the API.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Pilot participation</h2>
            <p>As a pilot participant, you understand that: the product is in beta, you may be asked for feedback, features may change without notice, and your usage helps us improve the product.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Intellectual property</h2>
            <p>SendPI owns the product, code, and brand. You own your own messages and communication. We do not claim any rights over your content.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Limitation of liability</h2>
            <p>SendPI is provided as-is. We are not responsible for any communication outcomes resulting from using the product. Use your own judgment before sending any message.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Governing law</h2>
            <p>These terms are governed by the laws of the State of Arizona, United States.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Changes</h2>
            <p>We may update these terms. We will notify you by email if we make significant changes.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Contact</h2>
            <p>For all legal questions: <a href="mailto:support@sendpi.ai" className="text-cyan-400 hover:underline">support@sendpi.ai</a></p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex gap-6">
          <Link to="/privacy" className="text-white/50 hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/" className="text-white/50 hover:text-white transition-colors">Back to Home</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
